<template>
<div>
  <img class="hot-shop-pic" :src="item.itemImgSmall" onclick="return false">
  <div class="shop-lab">
      <div class="shop-title ui-nowrap-two">{{item.itemName}}</div>
      <div class="ui-rows-m label-bot shop-m-android">
        <!-- 定金预售 -->
        <span class="label-red" :class="{'label-android':!isAndroid}" v-if="item.itemCategory == 3 && item.depositText != null">{{item.depositText}}</span>
        <!-- 特卖.满减/立减/N元X件/返券/买赠 -->
        <span class="label-red" :class="{'label-android':!isAndroid}" v-if="item.itemCategory == 1 || item.markFlag != 0">
                <i v-if="item.itemCategory == 1">特卖</i><i class="dot-red" v-if="item.itemCategory == 1 && item.markFlag != 0"></i><i v-if="item.markFlag == 1">满减</i><i v-if="item.markFlag == 2">立减</i><i v-if="item.markFlag == 3">{{item.markDescribe}}</i><i v-if="item.markFlag == 4">返券</i><i v-if="item.markFlag == 5">买赠</i>
            </span>
        <!-- 保税/包税/直邮 -->
        <span class="label-purple" :class="{'label-android':!isAndroid}" v-if="isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'bonded' || isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'directMail' || isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'packageTax'">
                <i v-if="isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'bonded'">保税</i><i v-if="isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'directMail'">直邮</i><i v-if="isOrdinaryOrCrossBorderGoods(item.itemChannel) == 'packageTax'">包税</i>
            </span>
        <!-- 预售/新品 -->
        <span class="label-khaki" :class="{'label-android':!isAndroid}" v-if="item.isNewItem == true || (item.shipmentsType != null && item.shipmentsType != 0)">
                <i v-if="item.shipmentsType != null && item.shipmentsType != 0">预售</i><i class="dot-khaki" v-if="(item.shipmentsType != null && item.shipmentsType != 0) && item.isNewItem == true"></i><i v-if="item.isNewItem == true">新品</i>
            </span>
    </div>
      <div class="shop-price ui-rows">
          <div class="red"><i class="red-rmb">¥</i>{{item.itemPrice}}</div>
          <div class="gray">¥{{item.itemVipPrice}}</div>
      </div>
  </div>
</div>
           
</template>

<script type="text/ecmascript-6">
import YunJi from '@/assets/js/YunJi'
export default {
  name: "commodities-list",
  data() {
    return {
      isAndroid:false,
    };
  },
  props:{
    index:{
      type:Number,
      default(){
        return 0;
      }
    },
    item:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  activated() {
    this.isAndroid = YunJi.getPhoneType();
  },
  methods: {
    /**
     * 跨境商品打标
     * @itemChannel 商品类型
     * itemChannel = 3 保税
     * itemChannel = 6 包税
     * itemChannel = 5、7、8、9、10、11、12、13 直邮
     */
    isOrdinaryOrCrossBorderGoods(itemChannel){
        var type = "";
        if(itemChannel == 3){
            type = "bonded";
        }else if(itemChannel == 6) {
            type = "packageTax";
        }else if(itemChannel == 5 || itemChannel == 7 || itemChannel == 8 || itemChannel == 9 || itemChannel == 10 || itemChannel == 11 || itemChannel == 12 || itemChannel == 13) {
            type = "directMail";
        }
        return type;
    },
  }
};
</script>

<style>
/*商品列表*/
.shop-titles { margin: .4rem 0; width: 100%; font-size: .32rem; color: #fff; text-align: center;}
.shop-titles .shop-title-tip { margin: 0 .24rem;}
.shop-titles .shop-l-bg,.shop-titles .shop-r-bg { display: inline-block; width: .96rem; height: .14rem;}
.shop-titles .shop-l-bg { background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/coupon-l-bg.png') no-repeat; background-size: 100% 100%;}
.shop-titles .shop-r-bg { background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/coupon-r-bg.png') no-repeat; background-size: 100% 100%;}
.shop-list{ margin: 0 auto; width: 7.14rem; justify-content: space-between; -webkit-justify-content: space-between; -moz-justify-content: space-between; -ms-justify-content: space-between;}
.shop-list li { width: 3.52rem; height: 5.46rem; margin-bottom: .1rem; background: #fff;border-radius: 0.16rem;position: relative;}
.shop-list li .hot-shop-pic {width: 3.52rem; height: 3.52rem;}
.shop-list li .shop-lab { padding: .08rem .16rem .16rem .16rem;}
.shop-list li .shop-lab .shop-title { font-size: .28rem; color: #1A1A1A; line-height: .36rem; text-align: left; min-height: .36rem;}
.shop-list li .shop-lab .ui-rows-m { margin:0.1rem 0; }
.shop-list li .shop-lab .shop-price { margin-top: .04rem;position: absolute;bottom: 0.2rem;}
.shop-list li .shop-lab .shop-price .red { font-size: .32rem; color: #F10D3B;}
.shop-list li .shop-lab .shop-price .red .red-rmb { font-size: .2rem;}
.shop-list li .shop-lab .shop-price .gray { font-size: .2rem; color: #A5A5A5; margin-left: .06rem; text-decoration: line-through;}

</style>
